// src/pages/Historico.jsx
import { useState, useMemo } from 'react';
import { formatCurrency, formatDate, monthLabel, currentMonthKey, getEntryBillKey } from '../services/billing';

const CAT_COLOR = { Alimentação:'#34d39920', Moradia:'#6c8fff20', Transporte:'#60a5fa20', Saúde:'#f8717120', Lazer:'#e879f920', Educação:'#fbbf2420', Roupas:'#fb923c20', Outros:'#94a3b820' };
const CAT_TXT   = { Alimentação:'#34d399',   Moradia:'#6c8fff',   Transporte:'#60a5fa',   Saúde:'#f87171',   Lazer:'#e879f9',   Educação:'#fbbf24',   Roupas:'#fb923c',   Outros:'#94a3b8' };
const RAMPS = {
  blue:{bg:'#6c8fff20',txt:'#6c8fff'}, purple:{bg:'#a78bfa20',txt:'#a78bfa'},
  teal:{bg:'#34d39920',txt:'#34d399'}, coral:{bg:'#fb923c20',txt:'#fb923c'},
  pink:{bg:'#f472b620',txt:'#f472b6'}, amber:{bg:'#fbbf2420',txt:'#fbbf24'},
};

export default function Historico({ cards, entries, onDeleteEntry }) {
  const [cardFilter, setCardFilter]   = useState('all');
  const [monthFilter, setMonthFilter] = useState('all');
  const [deleting, setDeleting] = useState(null);
  const now = currentMonthKey();

  const allBillKeys = useMemo(() =>
    [...new Set(entries.map(e => getEntryBillKey(e, cards)))].sort().reverse(),
    [entries, cards]
  );

  const filtered = useMemo(() => {
    let fe = entries;
    if (cardFilter  !== 'all') fe = fe.filter(e => e.cardId === cardFilter);
    if (monthFilter !== 'all') fe = fe.filter(e => getEntryBillKey(e, cards) === monthFilter);
    return fe;
  }, [entries, cardFilter, monthFilter, cards]);

  async function handleDelete(entry) {
    const msg = entry.type === 'parcel'
      ? `Remover todas as ${entry.parcelTotal} parcelas de "${entry.desc}"?`
      : `Remover "${entry.desc}"?`;
    if (!window.confirm(msg)) return;
    setDeleting(entry.id);
    try { await onDeleteEntry(entry); }
    catch (err) { alert('Erro ao remover.'); }
    finally { setDeleting(null); }
  }

  return (
    <div className="content">
      <div className="page-header">
        <div>
          <div className="page-title">Histórico</div>
          <div className="page-subtitle">{filtered.length} lançamento{filtered.length !== 1 ? 's' : ''}</div>
        </div>
      </div>

      <div className="chips-row">
        <button className={`chip${cardFilter === 'all' ? ' active' : ''}`} onClick={() => setCardFilter('all')}>Todos os cartões</button>
        {cards.map(c => (
          <button key={c.id} className={`chip${cardFilter === c.id ? ' active' : ''}`} onClick={() => setCardFilter(c.id)}>{c.name}</button>
        ))}
      </div>

      <div className="chips-row">
        <button className={`chip${monthFilter === 'all' ? ' active' : ''}`} onClick={() => setMonthFilter('all')}>Todos os meses</button>
        {allBillKeys.map(k => (
          <button key={k} className={`chip${monthFilter === k ? ' active' : ''}`} onClick={() => setMonthFilter(k)}>{monthLabel(k)}</button>
        ))}
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th style={{ width: 88 }}>Data</th>
              <th>Descrição</th>
              <th style={{ width: 100 }}>Categoria</th>
              <th style={{ width: 90 }}>Cartão</th>
              <th style={{ width: 80 }}>Fatura</th>
              <th style={{ width: 72 }}>Parcela</th>
              <th style={{ width: 105 }}>Valor</th>
              <th style={{ width: 40 }}></th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={8} className="empty-row">Nenhum lançamento encontrado.</td></tr>
            )}
            {filtered.map(e => {
              const card = cards.find(c => c.id === e.cardId);
              const r = card ? RAMPS[card.color] || RAMPS.blue : { bg: '#94a3b820', txt: '#94a3b8' };
              const bk = getEntryBillKey(e, cards);
              const isOpen = bk >= now;
              return (
                <tr key={e.id}>
                  <td>{formatDate(e.date)}</td>
                  <td className="td-primary" title={e.desc}>{e.desc}</td>
                  <td>
                    <span className="badge" style={{ background: CAT_COLOR[e.cat], color: CAT_TXT[e.cat] }}>{e.cat}</span>
                  </td>
                  <td>
                    {card
                      ? <span className="badge" style={{ background: r.bg, color: r.txt }}>{card.name}</span>
                      : '—'}
                  </td>
                  <td>
                    <span className={`badge ${isOpen ? 'badge-open' : 'badge-closed'}`}>{monthLabel(bk)}</span>
                  </td>
                  <td>
                    {e.type === 'parcel'
                      ? <span className="badge badge-parc">{e.parcelIdx}/{e.parcelTotal}</span>
                      : '—'}
                  </td>
                  <td className="td-primary">{formatCurrency(e.val)}</td>
                  <td>
                    <button
                      className="btn btn-xs btn-danger"
                      onClick={() => handleDelete(e)}
                      disabled={deleting === e.id}
                    >
                      {deleting === e.id ? '...' : '✕'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
